export const countries = [
  { text: 'Please select', value: null },
  { text: 'United States', value: 'United States' },
  { text: 'Åland Islands', value: 'Åland Islands' },
  { text: 'Albania', value: 'Albania' },
  { text: 'Algeria', value: 'Algeria' },
  { text: 'American Samoa', value: 'American Samoa' },
  { text: 'Andorra', value: 'Andorra' },
  { text: 'Angola', value: 'Angola' },
  { text: 'Anguilla', value: 'Anguilla' },
  { text: 'Antarctica', value: 'Antarctica' },
  { text: 'Antigua and Barbuda', value: 'Antigua And Barbuda' },
  { text: 'Argentina', value: 'Argentina' },
  { text: 'Armenia', value: 'Armenia' },
  { text: 'Aruba', value: 'Aruba' },
  { text: 'Australia', value: 'Australia' },
  { text: 'Austria', value: 'Austria' },
  { text: 'Azerbaijan', value: 'Azerbaijan' },
  { text: 'Bahamas', value: 'Bahamas' },
  { text: 'Bahrain', value: 'Bahrain' },
  { text: 'Bangladesh', value: 'Bangladesh' },
  { text: 'Barbados', value: 'Barbados' },
  { text: 'Belgium', value: 'Belgium' },
  { text: 'Belize', value: 'Belize' },
  { text: 'Benin', value: 'Benin' },
  { text: 'Bermuda', value: 'Bermuda' },
  { text: 'Bhutan', value: 'Bhutan' },
  { text: 'Bolivia', value: 'Bolivia' },
  { text: 'Botswana', value: 'Botswana' },
  { text: 'Bouvet Island', value: 'Bouvet Island' },
  { text: 'Brazil', value: 'Brazil' },
  {text: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory'},
  { text: 'Brunei Darussalam', value: 'Brunei Darussalam' },
  { text: 'Bulgaria', value: 'Bulgaria' },
  { text: 'Burkina Faso', value: 'Burkina Faso' },
  { text: 'Burundi', value: 'Burundi' },
  { text: 'Cambodia', value: 'Cambodia' },
  { text: 'Cameroon', value: 'Cameroon' },
  { text: 'Canada', value: 'Canada' },
  { text: 'Cape Verde', value: 'Cape Verde' },
  { text: 'Cayman Islands', value: 'Cayman Islands' },
  { text: 'Chad', value: 'Chad' },
  { text: 'Chile', value: 'Chile' },
  { text: 'Christmas Island', value: 'Christmas Island' },
  { text: 'Cocos (Keeling) Islands', value: 'Cocos Keeling Islands' },
  { text: 'Colombia', value: 'Colombia' },
  { text: 'Comoros', value: 'Comoros' },
  { text: 'Congo', value: 'Congo' },
  { text: 'Cook Islands', value: 'Cook Islands' },
  { text: 'Costa Rica', value: 'Costa Rica' },
  { text: 'Cote Divoire', value: 'Cote Divoire' },
  { text: 'Cyprus', value: 'Cyprus' },
  { text: 'Czech Republic', value: 'Czech Republic' },
  { text: 'Denmark', value: 'Denmark' },
  { text: 'Djibouti', value: 'Djibouti' },
  { text: 'Dominica', value: 'Dominica' },
  { text: 'Dominican Republic', value: 'Dominican Republic' },
  { text: 'Ecuador', value: 'Ecuador' },
  { text: 'Egypt', value: 'Egypt' },
  { text: 'El Salvador', value: 'El Salvador' },
  { text: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { text: 'Eritrea', value: 'Eritrea' },
  { text: 'Estonia', value: 'Estonia' },
  { text: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
  { text: 'Faroe Islands', value: 'Faroe Islands' },
  { text: 'Fiji', value: 'Fiji' },
  { text: 'Finland', value: 'Finland' },
  { text: 'France', value: 'France' },
  { text: 'French Guiana', value: 'French Guiana' },
  { text: 'French Polynesia', value: 'French Polynesia' },
  { text: 'French Southern Territories', value: 'French Southern Territories' },
  { text: 'Gabon', value: 'Gabon' },
  { text: 'Gambia', value: 'Gambia' },
  { text: 'Georgia', value: 'Georgia' },
  { text: 'Germany', value: 'Germany' },
  { text: 'Ghana', value: 'Ghana' },
  { text: 'Gibraltar', value: 'Gibraltar' },
  { text: 'Greece', value: 'Greece' },
  { text: 'Greenland', value: 'Greenland' },
  { text: 'Grenada', value: 'Grenada' },
  { text: 'Guadeloupe', value: 'Guadeloupe' },
  { text: 'Guam', value: 'Guam' },
  { text: 'Guatemala', value: 'Guatemala' },
  { text: 'Guernsey', value: 'Guernsey' },
  { text: 'Guinea', value: 'Guinea' },
  { text: 'Guinea-bissau', value: 'Guinea-bissau' },
  { text: 'Guyana', value: 'Guyana' },
  { text: 'Haiti', value: 'Haiti' },
  {text: 'Heard Island and Mcdonald Islands', value: 'Heard Island And Mcdonald Islands'},
  { text: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)' },
  { text: 'Honduras', value: 'Honduras' },
  { text: 'Hungary', value: 'Hungary' },
  { text: 'Iceland', value: 'Iceland' },
  { text: 'India', value: 'India' },
  { text: 'Indonesia', value: 'Indonesia' },
  { text: 'Ireland', value: 'Ireland' },
  { text: 'Isle of Man', value: 'Isle of Man' },
  { text: 'Israel', value: 'Israel' },
  { text: 'Italy', value: 'Italy' },
  { text: 'Jamaica', value: 'Jamaica' },
  { text: 'Japan', value: 'Japan' },
  { text: 'Jersey', value: 'Jersey' },
  { text: 'Jordan', value: 'Jordan' },
  { text: 'Kazakhstan', value: 'Kazakhstan' },
  { text: 'Kenya', value: 'Kenya' },
  { text: 'Kiribati', value: 'Kiribati' },
  { text: 'Kuwait', value: 'Kuwait' },
  { text: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { text: 'Lao Peoples Democratic Republic', value: 'Lao Peoples Democratic Republic' },
  { text: 'Latvia', value: 'Latvia' },
  { text: 'Lesotho', value: 'Lesotho' },
  { text: 'Liberia', value: 'Liberia' },
  { text: 'Liechtenstein', value: 'Liechtenstein' },
  { text: 'Lithuania', value: 'Lithuania' },
  { text: 'Luxembourg', value: 'Luxembourg' },
  { text: 'Macao', value: 'Macao' },
  {text: 'Macedonia, The Former Yugoslav Republic of', value: 'Macedonia The Former Yugoslav Republic of'},
  { text: 'Madagascar', value: 'Madagascar' },
  { text: 'Malawi', value: 'Malawi' },
  { text: 'Malaysia', value: 'Malaysia' },
  { text: 'Maldives', value: 'Maldives' },
  { text: 'Malta', value: 'Malta' },
  { text: 'Marshall Islands', value: 'Marshall Islands' },
  { text: 'Martinique', value: 'Martinique' },
  { text: 'Mauritania', value: 'Mauritania' },
  { text: 'Mauritius', value: 'Mauritius' },
  { text: 'Mayotte', value: 'Mayotte' },
  { text: 'Mexico', value: 'Mexico' },
  { text: 'Micronesia, Federated States of', value: 'Micronesia, Federated States Of' },
  { text: 'Moldova, Republic of', value: 'Moldova Republic of' },
  { text: 'Monaco', value: 'Monaco' },
  { text: 'Mongolia', value: 'Mongolia' },
  { text: 'Montserrat', value: 'Montserrat' },
  { text: 'Morocco', value: 'Morocco' },
  { text: 'Mozambique', value: 'Mozambique' },
  { text: 'Namibia', value: 'Namibia' },
  { text: 'Nauru', value: 'Nauru' },
  { text: 'Nepal', value: 'Nepal' },
  { text: 'Netherlands', value: 'Netherlands' },
  { text: 'Netherlands Antilles', value: 'Netherlands Antilles' },
  { text: 'New Caledonia', value: 'New Caledonia' },
  { text: 'New Zealand', value: 'New Zealand' },
  { text: 'Niger', value: 'Niger' },
  { text: 'Nigeria', value: 'Nigeria' },
  { text: 'Niue', value: 'Niue' },
  { text: 'Norfolk Island', value: 'Norfolk Island' },
  { text: 'North Macedonia', value: 'North Macedonia' },
  { text: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
  { text: 'Norway', value: 'Norway' },
  { text: 'Oman', value: 'Oman' },
  { text: 'Pakistan', value: 'Pakistan' },
  { text: 'Palau', value: 'Palau' },
  { text: 'Panama', value: 'Panama' },
  { text: 'Papua New Guinea', value: 'Papua New Guinea' },
  { text: 'Paraguay', value: 'Paraguay' },
  { text: 'Peru', value: 'Peru' },
  { text: 'Philippines', value: 'Philippines' },
  { text: 'Pitcairn', value: 'Pitcairn' },
  { text: 'Poland', value: 'Poland' },
  { text: 'Portugal', value: 'Portugal' },
  { text: 'Puerto Rico', value: 'Puerto Rico' },
  { text: 'Qatar', value: 'Qatar' },
  { text: 'RÉunion', value: 'RÉunion' },
  { text: 'Romania', value: 'Romania' },
  { text: 'Rwanda', value: 'Rwanda' },
  { text: 'Saint BarthÉlemy', value: 'Saint BarthÉlemy' },
  { text: 'Saint Helena', value: 'Saint Helena' },
  { text: 'Saint Kitts and Nevis', value: 'Saint Kitts And Nevis' },
  { text: 'Saint Lucia', value: 'Saint Lucia' },
  { text: 'Saint Martin', value: 'Saint Martin' },
  { text: 'Saint Pierre and Miquelon', value: 'Saint Pierre And Miquelon' },
  {text: 'Saint Vincent and The Grenadines', value: 'Saint Vincent And The Grenadines'},
  { text: 'Samoa', value: 'Samoa' },
  { text: 'San Marino', value: 'San Marino' },
  { text: 'Sao Tome and Principe', value: 'Sao Tome And Principe' },
  { text: 'Saudi Arabia', value: 'Saudi Arabia' },
  { text: 'Senegal', value: 'Senegal' },
  { text: 'Seychelles', value: 'Seychelles' },
  { text: 'Sierra Leone', value: 'Sierra Leone' },
  { text: 'Singapore', value: 'Singapore' },
  { text: 'Slovakia', value: 'Slovakia' },
  { text: 'Solomon Islands', value: 'Solomon Islands' },
  { text: 'South Africa', value: 'South Africa' },
  {text: 'South Georgia and The South Sandwich Islands', value: 'South Georgia And The South Sandwich Islands'},
  { text: 'Spain', value: 'Spain' },
  { text: 'Sri Lanka', value: 'Sri Lanka' },
  { text: 'Suriname', value: 'Suriname' },
  { text: 'Svalbard and Jan Mayen', value: 'Svalbard And Jan Mayen' },
  { text: 'Swaziland', value: 'Swaziland' },
  { text: 'Sweden', value: 'Sweden' },
  { text: 'Switzerland', value: 'Switzerland' },
  { text: 'Tajikistan', value: 'Tajikistan' },
  { text: 'Taiwan', value: 'Taiwan' },
  { text: 'Tanzania, United Republic of', value: 'Tanzania, United Republic Of' },
  { text: 'Thailand', value: 'Thailand' },
  { text: 'Timor-leste', value: 'Timor-leste' },
  { text: 'Togo', value: 'Togo' },
  { text: 'Tokelau', value: 'Tokelau' },
  { text: 'Tonga', value: 'Tonga' },
  { text: 'Trinidad and Tobago', value: 'Trinidad And Tobago' },
  { text: 'Tunisia', value: 'Tunisia' },
  { text: 'Turkey', value: 'Turkey' },
  { text: 'Turkmenistan', value: 'Turkmenistan' },
  { text: 'Turks and Caicos Islands', value: 'Turks And Caicos Islands' },
  { text: 'Tuvalu', value: 'Tuvalu' },
  { text: 'Uganda', value: 'Uganda' },
  { text: 'United Arab Emirates', value: 'United Arab Emirates' },
  { text: 'United Kingdom', value: 'United Kingdom' },
  { text: 'Uruguay', value: 'Uruguay' },
  { text: 'Uzbekistan', value: 'Uzbekistan' },
  { text: 'Vatican City State', value: 'Vatican City State' },
  { text: 'Vanuatu', value: 'Vanuatu' },
  { text: 'Viet Nam', value: 'Viet Nam' },
  { text: 'Virgin Islands, British', value: 'Virgin Islands, British' },
  { text: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
   { text: 'Wallis and Futuna', value: 'Wallis And Futuna' },
  { text: 'Western Sahara', value: 'Western Sahara' },
  { text: 'Zambia', value: 'Zambia' },
  { text: 'Zimbabwe', value: 'Zimbabwe' },
];

export const nonUSCountries = [
    { text: 'Afghanistan', value: 'Afghanistan' },
    { text: 'Åland Islands', value: 'Åland Islands' },
    { text: 'Albania', value: 'Albania' },
    { text: 'Algeria', value: 'Algeria' },
    { text: 'American Samoa', value: 'American Samoa' },
    { text: 'Andorra', value: 'Andorra' },
    { text: 'Angola', value: 'Angola' },
    { text: 'Anguilla', value: 'Anguilla' },
    { text: 'Antarctica', value: 'Antarctica' },
    { text: 'Antigua and Barbuda', value: 'Antigua And Barbuda' },
    { text: 'Argentina', value: 'Argentina' },
    { text: 'Armenia', value: 'Armenia' },
    { text: 'Aruba', value: 'Aruba' },
    { text: 'Australia', value: 'Australia' },
    { text: 'Austria', value: 'Austria' },
    { text: 'Azerbaijan', value: 'Azerbaijan' },
    { text: 'Bahamas', value: 'Bahamas' },
    { text: 'Bahrain', value: 'Bahrain' },
    { text: 'Bangladesh', value: 'Bangladesh' },
    { text: 'Barbados', value: 'Barbados' },
    { text: 'Belarus', value: 'Belarus' },
    { text: 'Belgium', value: 'Belgium' },
    { text: 'Belize', value: 'Belize' },
    { text: 'Benin', value: 'Benin' },
    { text: 'Bermuda', value: 'Bermuda' },
    { text: 'Bhutan', value: 'Bhutan' },
    { text: 'Bolivia', value: 'Bolivia' },
    { text: 'Bosnia and Herzegovina', value: 'Bosnia And Herzegovina' },
    { text: 'Botswana', value: 'Botswana' },
    { text: 'Bouvet Island', value: 'Bouvet Island' },
    { text: 'Brazil', value: 'Brazil' },
    { text: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' },
    { text: 'Brunei Darussalam', value: 'Brunei Darussalam' },
    { text: 'Bulgaria', value: 'Bulgaria' },
    { text: 'Burkina Faso', value: 'Burkina Faso' },
    { text: 'Burundi', value: 'Burundi' },
    { text: 'Cambodia', value: 'Cambodia' },
    { text: 'Cameroon', value: 'Cameroon' },
    { text: 'Canada', value: 'Canada' },
    { text: 'Cape Verde', value: 'Cape Verde' },
    { text: 'Cayman Islands', value: 'Cayman Islands' },
    { text: 'Central African Republic', value: 'Central African Republic' },
    { text: 'Chad', value: 'Chad' },
    { text: 'Chile', value: 'Chile' },
    { text: 'China', value: 'China' },
    { text: 'Christmas Island', value: 'Christmas Island' },
    { text: 'Cocos (Keeling) Islands', value: 'Cocos Keeling Islands' },
    { text: 'Colombia', value: 'Colombia' },
    { text: 'Comoros', value: 'Comoros' },
    { text: 'Congo', value: 'Congo' },
    { text: 'Congo, The Democratic Republic of The', value: 'Congo The Democratic Republic of The' },
    { text: 'Cook Islands', value: 'Cook Islands' },
    { text: 'Costa Rica', value: 'Costa Rica' },
    { text: 'Cote Divoire', value: 'Cote Divoire' },
    { text: 'Croatia', value: 'Croatia' },
    { text: 'Cuba', value: 'Cuba' },
    { text: 'Cyprus', value: 'Cyprus' },
    { text: 'Czech Republic', value: 'Czech Republic' },
    { text: 'Denmark', value: 'Denmark' },
    { text: 'Djibouti', value: 'Djibouti' },
    { text: 'Dominica', value: 'Dominica' },
    { text: 'Dominican Republic', value: 'Dominican Republic' },
    { text: 'Ecuador', value: 'Ecuador' },
    { text: 'Egypt', value: 'Egypt' },
    { text: 'El Salvador', value: 'El Salvador' },
    { text: 'Equatorial Guinea', value: 'Equatorial Guinea' },
    { text: 'Eritrea', value: 'Eritrea' },
    { text: 'Estonia', value: 'Estonia' },
    { text: 'Ethiopia', value: 'Ethiopia' },
    { text: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
    { text: 'Faroe Islands', value: 'Faroe Islands' },
    { text: 'Fiji', value: 'Fiji' },
    { text: 'Finland', value: 'Finland' },
    { text: 'France', value: 'France' },
    { text: 'French Guiana', value: 'French Guiana' },
    { text: 'French Polynesia', value: 'French Polynesia' },
    { text: 'French Southern Territories', value: 'French Southern Territories' },
    { text: 'Gabon', value: 'Gabon' },
    { text: 'Gambia', value: 'Gambia' },
    { text: 'Georgia', value: 'Georgia' },
    { text: 'Germany', value: 'Germany' },
    { text: 'Ghana', value: 'Ghana' },
    { text: 'Gibraltar', value: 'Gibraltar' },
    { text: 'Greece', value: 'Greece' },
    { text: 'Greenland', value: 'Greenland' },
    { text: 'Grenada', value: 'Grenada' },
    { text: 'Guadeloupe', value: 'Guadeloupe' },
    { text: 'Guam', value: 'Guam' },
    { text: 'Guatemala', value: 'Guatemala' },
    { text: 'Guernsey', value: 'Guernsey' },
    { text: 'Guinea', value: 'Guinea' },
    { text: 'Guinea-bissau', value: 'Guinea-bissau' },
    { text: 'Guyana', value: 'Guyana' },
    { text: 'Haiti', value: 'Haiti' },
    { text: 'Heard Island and Mcdonald Islands', value: 'Heard Island And Mcdonald Islands' },
    { text: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)' },
    { text: 'Honduras', value: 'Honduras' },
    { text: 'Hong Kong', value: 'Hong Kong' },
    { text: 'Hungary', value: 'Hungary' },
    { text: 'Iceland', value: 'Iceland' },
    { text: 'India', value: 'India' },
    { text: 'Indonesia', value: 'Indonesia' },
    { text: 'Iran, Islamic Republic of', value: 'Iran Islamic Republic of' },
    { text: 'Iraq', value: 'Iraq' },
    { text: 'Ireland', value: 'Ireland' },
    { text: 'Isle of Man', value: 'Isle of Man' },
    { text: 'Israel', value: 'Israel' },
    { text: 'Italy', value: 'Italy' },
    { text: 'Jamaica', value: 'Jamaica' },
    { text: 'Japan', value: 'Japan' },
    { text: 'Jersey', value: 'Jersey' },
    { text: 'Jordan', value: 'Jordan' },
    { text: 'Kazakhstan', value: 'Kazakhstan' },
    { text: 'Kenya', value: 'Kenya' },
    { text: 'Kiribati', value: 'Kiribati' },
    { text: 'Korea, Democratic Peoples Republic of', value: 'Korea Democratic Peoples Republic of' },
    { text: 'Korea, Republic of', value: 'Korea, Republic of' },
    { text: 'Kuwait', value: 'Kuwait' },
    { text: 'Kyrgyzstan', value: 'Kyrgyzstan' },
    { text: 'Lao Peoples Democratic Republic', value: 'Lao Peoples Democratic Republic' },
    { text: 'Latvia', value: 'Latvia' },
    { text: 'Lebanon', value: 'Lebanon' },
    { text: 'Lesotho', value: 'Lesotho' },
    { text: 'Liberia', value: 'Liberia' },
    { text: 'Libyan Arab Jamahiriya', value: 'Libyan Arab Jamahiriya' },
    { text: 'Liechtenstein', value: 'Liechtenstein' },
    { text: 'Lithuania', value: 'Lithuania' },
    { text: 'Luxembourg', value: 'Luxembourg' },
    { text: 'Macao', value: 'Macao' },
    { text: 'Macedonia, The Former Yugoslav Republic of', value: 'Macedonia The Former Yugoslav Republic of' },
    { text: 'Madagascar', value: 'Madagascar' },
    { text: 'Malawi', value: 'Malawi' },
    { text: 'Malaysia', value: 'Malaysia' },
    { text: 'Maldives', value: 'Maldives' },
    { text: 'Mali', value: 'Mali' },
    { text: 'Malta', value: 'Malta' },
    { text: 'Marshall Islands', value: 'Marshall Islands' },
    { text: 'Martinique', value: 'Martinique' },
    { text: 'Mauritania', value: 'Mauritania' },
    { text: 'Mauritius', value: 'Mauritius' },
    { text: 'Mayotte', value: 'Mayotte' },
    { text: 'Mexico', value: 'Mexico' },
    { text: 'Micronesia, Federated States of', value: 'Micronesia, Federated States Of' },
    { text: 'Moldova, Republic of', value: 'Moldova Republic of' },
    { text: 'Monaco', value: 'Monaco' },
    { text: 'Mongolia', value: 'Mongolia' },
    { text: 'Montenegro', value: 'Montenegro' },
    { text: 'Montserrat', value: 'Montserrat' },
    { text: 'Morocco', value: 'Morocco' },
    { text: 'Mozambique', value: 'Mozambique' },
    { text: 'Myanmar', value: 'Myanmar' },
    { text: 'Namibia', value: 'Namibia' },
    { text: 'Nauru', value: 'Nauru' },
    { text: 'Nepal', value: 'Nepal' },
    { text: 'Netherlands', value: 'Netherlands' },
    { text: 'Netherlands Antilles', value: 'Netherlands Antilles' },
    { text: 'New Caledonia', value: 'New Caledonia' },
    { text: 'New Zealand', value: 'New Zealand' },
    { text: 'Nicaragua', value: 'Nicaragua' },
    { text: 'Niger', value: 'Niger' },
    { text: 'Nigeria', value: 'Nigeria' },
    { text: 'Niue', value: 'Niue' },
    { text: 'Norfolk Island', value: 'Norfolk Island' },
    { text: 'North Macedonia', value: 'North Macedonia' },
    { text: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
    { text: 'Norway', value: 'Norway' },
    { text: 'Oman', value: 'Oman' },
    { text: 'Pakistan', value: 'Pakistan' },
    { text: 'Palau', value: 'Palau' },
    { text: 'Palestinian Territory, Occupied', value: 'Palestinian Territory, Occupied' },
    { text: 'Panama', value: 'Panama' },
    { text: 'Papua New Guinea', value: 'Papua New Guinea' },
    { text: 'Paraguay', value: 'Paraguay' },
    { text: 'Peru', value: 'Peru' },
    { text: 'Philippines', value: 'Philippines' },
    { text: 'Pitcairn', value: 'Pitcairn' },
    { text: 'Poland', value: 'Poland' },
    { text: 'Portugal', value: 'Portugal' },
    { text: 'Puerto Rico', value: 'Puerto Rico' },
    { text: 'Qatar', value: 'Qatar' },
    { text: 'RÉunion', value: 'RÉunion' },
    { text: 'Romania', value: 'Romania' },
    { text: 'Russian Federation', value: 'Russian Federation' },
    { text: 'Rwanda', value: 'Rwanda' },
    { text: 'Saint BarthÉlemy', value: 'Saint BarthÉlemy' },
    { text: 'Saint Helena', value: 'Saint Helena' },
    { text: 'Saint Kitts and Nevis', value: 'Saint Kitts And Nevis' },
    { text: 'Saint Lucia', value: 'Saint Lucia' },
    { text: 'Saint Martin', value: 'Saint Martin' },
    { text: 'Saint Pierre and Miquelon', value: 'Saint Pierre And Miquelon' },
    { text: 'Saint Vincent and The Grenadines', value: 'Saint Vincent And The Grenadines' },
    { text: 'Samoa', value: 'Samoa' },
    { text: 'San Marino', value: 'San Marino' },
    { text: 'Sao Tome and Principe', value: 'Sao Tome And Principe' },
    { text: 'Saudi Arabia', value: 'Saudi Arabia' },
    { text: 'Senegal', value: 'Senegal' },
    { text: 'Serbia', value: 'Serbia' },
    { text: 'Seychelles', value: 'Seychelles' },
    { text: 'Sierra Leone', value: 'Sierra Leone' },
    { text: 'Singapore', value: 'Singapore' },
    { text: 'Slovakia', value: 'Slovakia' },
    { text: 'Slovenia', value: 'Slovenia' },
    { text: 'Solomon Islands', value: 'Solomon Islands' },
    { text: 'Somalia', value: 'Somalia' },
    { text: 'South Africa', value: 'South Africa' },
    { text: 'South Georgia and The South Sandwich Islands', value: 'South Georgia And The South Sandwich Islands' },
    { text: 'Spain', value: 'Spain' },
    { text: 'Sri Lanka', value: 'Sri Lanka' },
    { text: 'Sudan', value: 'Sudan' },
    { text: 'Suriname', value: 'Suriname' },
    { text: 'Svalbard and Jan Mayen', value: 'Svalbard And Jan Mayen' },
    { text: 'Swaziland', value: 'Swaziland' },
    { text: 'Sweden', value: 'Sweden' },
    { text: 'Switzerland', value: 'Switzerland' },
    { text: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
    { text: 'Tajikistan', value: 'Tajikistan' },
    { text: 'Taiwan', value: 'Taiwan' },
    { text: 'Tanzania, United Republic of', value: 'Tanzania, United Republic Of' },
    { text: 'Thailand', value: 'Thailand' },
    { text: 'Timor-leste', value: 'Timor-leste' },
    { text: 'Togo', value: 'Togo' },
    { text: 'Tokelau', value: 'Tokelau' },
    { text: 'Tonga', value: 'Tonga' },
    { text: 'Trinidad and Tobago', value: 'Trinidad And Tobago' },
    { text: 'Tunisia', value: 'Tunisia' },
    { text: 'Turkey', value: 'Turkey' },
    { text: 'Turkmenistan', value: 'Turkmenistan' },
    { text: 'Turks and Caicos Islands', value: 'Turks And Caicos Islands' },
    { text: 'Tuvalu', value: 'Tuvalu' },
    { text: 'Uganda', value: 'Uganda' },
    { text: 'Ukraine', value: 'Ukraine' },
    { text: 'United Arab Emirates', value: 'United Arab Emirates' },
    { text: 'United Kingdom', value: 'United Kingdom' },
    { text: 'Uruguay', value: 'Uruguay' },
    { text: 'Uzbekistan', value: 'Uzbekistan' },
    { text: 'Vatican City State', value: 'Vatican City State' },
    { text: 'Vanuatu', value: 'Vanuatu' },
    { text: 'Venezuela', value: 'Venezuela' },
    { text: 'Viet Nam', value: 'Viet Nam' },
    { text: 'Virgin Islands, British', value: 'Virgin Islands, British' },
    { text: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
    { text: 'Wallis and Futuna', value: 'Wallis And Futuna' },
    { text: 'Western Sahara', value: 'Western Sahara' },
    { text: 'Yemen', value: 'Yemen' },
    { text: 'Zambia', value: 'Zambia' },
    { text: 'Zimbabwe', value: 'Zimbabwe' },
];

export const euCountries = [
    { text: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)' },
    { text: 'North Macedonia', value: 'North Macedonia' },
    { text: 'Albania', value: 'Albania' },
    { text: 'Andorra', value: 'Andorra' },
    { text: 'Austria', value: 'Austria' },
    { text: 'Belarus', value: 'Belarus' },
    { text: 'Belgium', value: 'Belgium' },
    { text: 'Bosnia And Herzegovina', value: 'Bosnia And Herzegovina' },
    { text: 'Bulgaria', value: 'Bulgaria' },
    { text: 'Croatia', value: 'Croatia' },
    { text: 'Czech Republic', value: 'Czech Republic' },
    { text: 'Denmark', value: 'Denmark' },
    { text: 'Estonia', value: 'Estonia' },
    { text: 'Finland', value: 'Finland' },
    { text: 'France', value: 'France' },
    { text: 'Germany', value: 'Germany' },
    { text: 'Greece', value: 'Greece' },
    { text: 'Hungary', value: 'Hungary' },
    { text: 'Iceland', value: 'Iceland' },
    { text: 'Ireland', value: 'Ireland' },
    { text: 'Italy', value: 'Italy' },
    { text: 'Latvia', value: 'Latvia' },
    { text: 'Liechtenstein', value: 'Liechtenstein' },
    { text: 'Lithuania', value: 'Lithuania' },
    { text: 'Luxembourg', value: 'Luxembourg' },
    { text: 'Malta', value: 'Malta' },
    { text: 'Moldova, Republic of', value: 'Moldova, Republic of' },
    { text: 'Monaco', value: 'Monaco' },
    { text: 'Montenegro', value: 'Montenegro' },
    { text: 'Netherlands', value: 'Netherlands' },
    { text: 'Norway', value: 'Norway' },
    { text: 'Poland', value: 'Poland' },
    { text: 'Portugal', value: 'Portugal' },
    { text: 'Romania', value: 'Romania' },
    { text: 'Russian Federation', value: 'Russian Federation' },
    { text: 'San Marino', value: 'San Marino' },
    { text: 'Serbia', value: 'Serbia' },
    { text: 'Slovakia', value: 'Slovakia' },
    { text: 'Slovenia', value: 'Slovenia' },
    { text: 'Spain', value: 'Spain' },
    { text: 'Sweden', value: 'Sweden' },
    { text: 'Switzerland', value: 'Switzerland' },
    { text: 'Ukraine', value: 'Ukraine' },
    { text: 'United Kingdom', value: 'United Kingdom' },
];
export const states = [
    { text: 'Please select', value: null },
    { text: 'Alabama', value: 'AL' },
    { text: 'Alaska', value: 'AK' },
    { text: 'Arizona', value: 'AZ' },
    { text: 'Arkansas', value: 'AR' },
  { text: 'California', value: 'CA' },
  { text: 'Colorado', value: 'CO' },
  { text: 'Connecticut', value: 'CT' },
  { text: 'Delaware', value: 'DE' },
  { text: 'Florida', value: 'FL' },
  { text: 'Georgia', value: 'GA' },
  { text: 'Hawaii', value: 'HI' },
  { text: 'Idaho', value: 'ID' },
  { text: 'Illinois', value: 'IL' },
  { text: 'Indiana', value: 'IN' },
  { text: 'Iowa', value: 'IA' },
  { text: 'Kansas', value: 'KS' },
  { text: 'Kentucky', value: 'KY' },
  { text: 'Louisiana', value: 'LA' },
  { text: 'Maine', value: 'ME' },
  { text: 'Maryland', value: 'MD' },
  { text: 'Massachusetts', value: 'MA' },
  { text: 'Michigan', value: 'MI' },
  { text: 'Minnesota', value: 'MN' },
  { text: 'Mississippi', value: 'MS' },
  { text: 'Missouri', value: 'MO' },
  { text: 'Montana', value: 'MT' },
  { text: 'Nebraska', value: 'NE' },
  { text: 'Nevada', value: 'NV' },
  { text: 'New Hampshire', value: 'NH' },
  { text: 'New Jersey', value: 'NJ' },
  { text: 'New Mexico', value: 'NM' },
  { text: 'New York', value: 'NY' },
  { text: 'North Carolina', value: 'NC' },
  { text: 'North Dakota', value: 'ND' },
  { text: 'Ohio', value: 'OH' },
  { text: 'Oklahoma', value: 'OK' },
  { text: 'Oregon', value: 'OR' },
  { text: 'Pennsylvania', value: 'PA' },
  { text: 'Rhode Island', value: 'RI' },
  { text: 'South Carolina', value: 'SC' },
  { text: 'South Dakota', value: 'SD' },
  { text: 'Tennessee', value: 'TN' },
  { text: 'Texas', value: 'TX' },
  { text: 'Utah', value: 'UT' },
  { text: 'Vermont', value: 'VT' },
  { text: 'Virginia', value: 'VA' },
  { text: 'Washington', value: 'WA' },
  { text: 'West Virginia', value: 'WV' },
  { text: 'Wisconsin', value: 'WI' },
  { text: 'Wyoming', value: 'WY' },
];
export const providers = [
  { text: 'Please select', value: null },
  { text: 'Verizon', value: '1' },
  { text: 'Sprint', value: '2' },
  { text: 'AT & T', value: '3' },
  { text: 'T - Mobile', value: '4' },
  { text: 'Nextel', value: '5' },
  { text: 'Virgin Mobile', value: '6' },
  { text: 'Rogers Wireless', value: '7' },
  { text: 'US Cellular', value: '8' },
  { text: 'Alltel', value: '9' },
  { text: 'O2', value: '10' },
  { text: 'Boost Mobile', value: '11' },
  { text: 'Fido', value: '12' },
  { text: 'MetroPCS', value: '13' },
  { text: 'Straight Talk', value: '14' },
  { text: 'Google Project Fi', value: '15' },
];

export const zones = [
    { text: 'Please select', value: null },
    { text: 'Eastern', value: '1' },
    { text: 'Central', value: '2' },
    { text: 'Mountain', value: '3' },
    { text: 'Pacific', value: '4' },
    { text: 'Central European Time', value: '5' },
    { text: 'Other', value: '-9' },
];

export const supportTypes = [
  { text: 'Please select', value: '' },
  { value: '1', text: 'NIH Intramural Research' },
  { value: '2', text: 'NIH Extramural Funding' },
  { value: '3', text: 'Other Federal Funding' },
  { value: '4', text: 'State Funding' },
  { value: '5', text: 'Private Foundation' },
  { value: '6', text: 'Funding Outside of the United States' },
  { value: '7', text: 'Industry' },
  { value: '8', text: 'Institutional/Departmental' },
  { value: '9', text: 'Pending' },
  { value: '-9', text: 'Other' },
];

export const provinces = [
    { text: 'Please select', value: null },
    { value: 'AB', text: 'Alberta' },
    { value: 'BC', text: 'British Columbia' },
    { value: 'MB', text: 'Manitoba' },
    { value: 'NB', text: 'New Brunswick' },
    { value: 'NL', text: 'Newfoundland' },
    { value: 'NS', text: 'Nova Scotia' },
    { value: 'NT', text: 'Northwest Territories' },
    { value: 'NU', text: 'Nunavut' },
    { value: 'ON', text: 'Ontario' },
    { value: 'PE', text: 'Prince Edward Island' },
    { value: 'QC', text: 'Quebec' },
    { value: 'SK', text: 'Saskatchewan' },
    { value: 'YT', text: 'Yukon Territory' },
];

export const israelDistricts = [
    { text: 'Please select', value: null },
    { value: 'Center', text: 'Center' },
    { value: 'Haifa', text: 'Haifa' },
    { value: 'Jerusalem', text: 'Jerusalem' },
    { value: 'North', text: 'North' },
    { value: 'South', text: 'South' },
    { value: 'Tel Aviv', text: 'Tel Aviv' },
    { value: 'Other', text: 'Other' },
];

export const germanyStates = [
    { text: 'Please select', value: null },
    { value: 'Baden-Württemberg', text: 'Baden-Württemberg' },
    { value: 'Bavaria', text: 'Bavaria' },
    { value: 'Berlin', text: 'Berlin' },
    { value: 'Brandenburg', text: 'Brandenburg' },
    { value: 'Bremen', text: 'Bremen' },
    { value: 'Hamburg', text: 'Hamburg' },
    { value: 'Hesse', text: 'Hesse' },
    { value: 'Lower Saxony', text: 'Lower Saxony' },
    { value: 'Mecklenburg-Vorpommern', text: 'Mecklenburg-Vorpommern' },
    { value: 'North Rhine-Westphalia', text: 'North Rhine-Westphalia' },
    { value: 'Rhineland-Palatinate', text: 'Rhineland-Palatinate' },
    { value: 'Saarland', text: 'Saarland' },
    { value: 'Saxony', text: 'Saxony' },
    { value: 'Saxony-Anhalt', text: 'Saxony-Anhalt' },
    { value: 'Schleswig-Holstein', text: 'Schleswig-Holstein' },
    { value: 'Thuringia', text: 'Thuringia' },
];

export const austrailiaStates = [
    { text: 'Please select', value: null },
    { value: 'Ashmore and Cartier Islands', text: 'Ashmore and Cartier Islands' },
    { value: 'Australian Antarctic Territory', text: 'Australian Antarctic Territory' },
    { value: 'Australian Capital Territory', text: 'Australian Capital Territory' },
    { value: 'Christmas Island', text: 'Christmas Island' },
    { value: 'Cocos (Keeling) Islands', text: 'Cocos (Keeling) Islands' },
    { value: 'Coral Sea Islands Territory', text: 'Coral Sea Islands Territory' },
    { value: 'Heard and McDonald Islands', text: 'Heard and McDonald Islands' },
    { value: 'Jervis Bay Territory', text: 'Jervis Bay Territory' },
    { value: 'New South Wales', text: 'New South Wales' },
    { value: 'Norfolk Island', text: 'Norfolk Island' },
    { value: 'Northern Territory', text: 'Northern Territory' },
    { value: 'Queensland', text: 'Queensland' },
    { value: 'South Australia', text: 'South Australia' },
    { value: 'Tasmania', text: 'Tasmania' },
    { value: 'Territory of Papua and New Guinea', text: 'Territory of Papua and New Guinea' },
    { value: 'Victoria', text: 'Victoria' },
    { value: 'Western Australia', text: 'Western Australia ' },
];

export const supportTypesGrantFunding = [
    { text: 'Please select', value: '' },
    { value: '1', text: 'NIH Intramural Research' },
    { value: '2', text: 'NIH Extramural Funding' },
    { value: '3', text: 'Other Federal Funding' },
    { value: '4', text: 'State Funding' },
    { value: '5' , text: 'Private Foundation' },
    { value: '6', text: 'Funding Outside of the United States' },
    { value: '7', text: 'Industry' },
    { value: '8', text: 'Institutional/Departmental' },
    { value: '9', text: 'Pending' },
    { value: '-9', text: 'Other' },
];
export const contactTypes = [
    { text: 'Please select', value: '' },
    { value: '1', text: 'Financial Contact'},
    { value: '2', text: 'Primary Contact' },
    { value: '3', text: 'Additional Contact' },
    { value: '4', text: 'Collaborator' },
];
export const contactTypesWithPrimary = [
    { text: 'Please select', value: '' },
    { value: '1', text: 'Financial Contact' },
    { value: '3', text: 'Additional Contact' },
    { value: '4', text: 'Collaborator' },
];
export const degrees = [
    { value: 1, text: 'MD', checked: true },
    { value: 2, text: 'PhD', selected: true },
    { value: 3, text: 'DPhil' },
    { value: 4, text: 'DVM' },
    { value: 5, text: 'MS' },
    { value: 6, text: 'None' },
    { value: -9, text: 'Other' },
];
export const IdealMinOptions = [
    { value: 1, text: 'Yes' },
    { value: 0, text: 'No' },
];
export const meetingOptions = [
    { text: 'Please select', value: 'null' },
    { text: 'American Diabetes Association (ADA) Annual Meeting', value: '1' },
    { text: 'Human Islet Research Network (HIRN) Annual Meeting', value: '2' },
    { text: 'International Pancreas & islet Transplant Association (IPITA) World Congress', value: '3'},
    { text: 'Levine-Riggs Diabetes Research Symposium', value: '4' },
    { text: 'Other', value: '-9' },
];
export const blockingOptions = [
    { text: 'Please select', value: '0', selected: true},
    { text: 'Previous Low Counts of Islets', value: '1' },
    { text: 'Previous Poor Quality Shipments', value: '2' },
    { text: 'Geographical Location', value: '3' },
    { text: 'Shipments with Poor Function', value: '4' },
    { text: 'Advice from Colleagues to Avoid', value: '5' },
    { text: 'Secrecy of Media and Process', value: '6' },
    { text: 'Other', value: '-9' },
];
export const shippingSerumOptions = [
    { text: 'Please select', value: 'null' },
    { text: 'Human AB Serum', value: '1' },
    { text: 'No Preference', value: '2' },
];
export const centerOptions = [
    { text: 'Columbia University Islet Core', value: 127 },
    { text: 'Imagine Islet Center, Imagine Pharma', value: 126 },
    { text: 'Nationwide Children’s Islet Biology Center', value: 131 },
    { text: 'Prodo Labs Human Islet Isolation Center', value: 117 },
    { text: 'Southern California Islet Cell Resource Center, City of Hope', value: 109 },
    { text: 'University of Arizona, Institute for Cellular Transplantation', value: 130 },
    { text: 'University of Miami', value: 105 },
    { text: 'University of Pennsylvania Islet Transplant Center', value: 107 },
    { text: 'University of Wisconsin Human Islet Core', value: 113 },
    { text: 'VCU Islet Cell Processing Lab', value: 132 },
];
export const iacucStatus = [
    { text: 'Please select', value: 'null' },
    { text: 'Approved', value: '1' },
    { text: 'Approval Pending', value: '2' },
    { text: 'Not Applicable', value: '3' },
    { text: 'Not Stated', value: '4' },
];
export const shippingCarriers = [
    { text: '', value: '' },
    { value: '1', text: 'Fed Ex' },
    { value: '2', text: 'UPS' },
];
export const shippingFedCarrier = [
    { text: 'Fed Ex', value: '1'},
];
export const shippingUPSCarrier = [
    { text: '', value: '' },
    { value: '2', text: 'UPS' },
];
export const shippingCarriers2 = [
    { text: '', value: '' },
    { value: '1', text: 'Fed Ex' },
    { value: '2', text: 'UPS' },
];
export const primaryShippingCarriers = [
    { text: '', value: '' },
    { value: '1', text: 'Fed Ex' },
    { value: '2', text: 'UPS' },
];
export const secondaryShippingCarriers = [
    { text: '', value: '' },
    { value: '1', text: 'Fed Ex' },
    { value: '2', text: 'UPS' },
];
export const genderPreferenceOptions = [
    { value: '', text: '' },
    { value: 1, text: 'Male' },
    { value: 2, text: 'Female' },
];
export const referrals = [
    { value: 1, text: 'Website (http://iidp.coh.org)', checked: true },
    { value: 2, text: 'Ad in scientific journal (e.g. Diabetes, Transplantation, Journal of Cell Biology, etc.)' },
    { value: 3, text: 'Word of Mouth' },
    { value: -9, text: 'Other' },
    { value: 4, text: 'Meeting/Conference' },
];
